import * as LoyaltyApiService from '../services/api/requests/Loyalty'

// gets loyalty vouchers of users
export const doGetUserLoyaltyVouchers = ({
  accessToken,
  setActiveVouchers = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => async active => {
  await LoyaltyApiService.getAllLoyaltyVouchers({ active, accessToken })
    .then(response => {
      setActiveVouchers(response.data)
      onSuccess(response)
    })
    .catch(error => {
      onError(error)
    })
}

// get loyalty points of users
export const doGetUserLoyaltyPoints = async ({
  accessToken,
  isAdvancedAccount,
  setLoyaltyPoints = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => {
  if (accessToken && isAdvancedAccount) {
    try {
      const response = await LoyaltyApiService.getLoyaltyPoints(accessToken)
      setLoyaltyPoints(response.data)
      onSuccess(response)
    } catch (error) {
      onError(error)
    }
  }
}
